<script>
  import { Accordion, AccordionSection, Button } from 'attractions'

  import 'unplugin-icons/types/svelte'
  import MdiChevronDown from '~icons/mdi/chevron-down'

  import ApiMoveCommand from './ApiMoveCommand.svelte'
  import ApiTurnCommand from './ApiTurnCommand.svelte'
  import ApiPickupCommand from './ApiPickupCommand.svelte'
  import ApiDropCommand from './ApiDropCommand.svelte'
  import ApiShootCommand from './ApiShootCommand.svelte'
</script>

<Accordion let:closeOtherPanels>
  <AccordionSection on:panel-open={closeOtherPanels}>
    <div slot="handle" let:toggle>
      <Button on:click={toggle}>addMoveCommand(int steps[, string direction])<MdiChevronDown /></Button>
    </div>
    <ApiMoveCommand />
  </AccordionSection>
  <AccordionSection on:panel-open={closeOtherPanels}>
    <div slot="handle" let:toggle>
      <Button on:click={toggle}>addTurnCommand(string direction | int angle)<MdiChevronDown /></Button>
    </div>
    <ApiTurnCommand />
  </AccordionSection>
  <AccordionSection on:panel-open={closeOtherPanels}>
    <div slot="handle" let:toggle>
      <Button on:click={toggle}>addPickupCommand()<MdiChevronDown /></Button>
    </div>
    <ApiPickupCommand />
  </AccordionSection>
  <AccordionSection on:panel-open={closeOtherPanels}>
    <div slot="handle" let:toggle>
      <Button on:click={toggle}>addDropCommand()<MdiChevronDown /></Button>
    </div>
    <ApiDropCommand />
  </AccordionSection>
  <AccordionSection on:panel-open={closeOtherPanels}>
    <div slot="handle" let:toggle>
      <Button on:click={toggle}>addShootCommand(float angle, int power)<MdiChevronDown /></Button>
    </div>
    <ApiShootCommand />
  </AccordionSection>
</Accordion>
